import { experimentalRichEditPolicy, type RichEditSkin, type RichEditVariant } from '@/app/richEdit'

export const GALLERY_RICH_EDIT_VARIANT: RichEditVariant = 'extended'
export const RICH_EDIT_POLICY = experimentalRichEditPolicy(GALLERY_RICH_EDIT_VARIANT)

export const cardsRichEditSkin: RichEditSkin = {
  root: 'flex min-h-0 flex-1 flex-col bg-white',
  modeBar: 'flex min-h-10 flex-wrap items-center gap-2 border-b border-slate-200 bg-slate-50 px-3 py-1.5',
  modeButton: 'h-7 cursor-pointer rounded-lg border border-slate-300 bg-white px-2 text-xs text-slate-700 hover:bg-slate-100',
  modeButtonActive: 'h-7 cursor-pointer rounded-lg border border-violet-600 bg-violet-600 px-2 text-xs font-semibold text-white',
  toolbar: 'flex min-h-10 flex-wrap items-center gap-2 border-b border-slate-200 bg-white px-3 py-1.5',
  toolbarGroup: 'flex flex-wrap items-center gap-1',
  button: 'flex h-7 min-w-7 items-center justify-center rounded-lg border border-slate-300 bg-white px-2 text-xs text-slate-700 hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40',
  buttonActive: 'border-violet-600 bg-violet-600 text-white',
  select: 'h-7 rounded-lg border border-slate-300 bg-white px-2 text-xs text-slate-700',
  color: 'h-7 w-8 cursor-pointer rounded-lg border border-slate-300 bg-white p-0.5',
  surfaceWrap: 'min-h-0 flex-1',
  surface: 'box-border h-full min-h-[420px] w-full overflow-auto bg-white px-6 py-5 text-base leading-7 text-slate-900 outline-none [&_a]:text-violet-700 [&_img]:max-w-full [&_table]:border-collapse [&_td]:min-w-16 [&_td]:p-1',
  status: 'ml-auto text-[10px] text-slate-500',
  blocks: {
    toolbar: 'flex flex-wrap items-center gap-1 border-b border-slate-200 bg-white px-3 py-1.5',
    stage: 'relative min-h-[420px] overflow-auto bg-slate-100',
    block: 'group absolute box-border cursor-move overflow-hidden rounded-lg border border-slate-300 bg-white shadow-sm',
    blockSelected: 'border-violet-600 ring-2 ring-violet-600/20',
    blockContent: 'h-full overflow-auto p-3 text-sm text-slate-800 outline-none cursor-text',
    handle: 'pointer-events-none absolute bottom-0 right-0 bg-violet-600 px-1 text-[10px] text-white',
    empty: 'flex min-h-[420px] items-center justify-center text-sm text-slate-500',
  },
  canvas: {
    toolbar: 'flex flex-wrap items-center gap-1 border-b border-slate-200 bg-white px-3 py-1.5',
    stage: 'min-h-[420px] overflow-auto bg-slate-100 p-3',
    viewport: 'mx-auto w-fit bg-white shadow-sm',
    fallback: 'mx-auto max-w-full bg-white [&_svg]:block [&_svg]:h-auto [&_svg]:max-w-full',
  },
}
